import automobyApi from '../Api';

export const useTransaction = (carId) => {
   
   //useEffect(() => {
   // fetchTransactions(carId, typeId);
   //}, []);

   const fetchTransactions = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
      };
  
      automobyApi
        .post("/transaction/list", requestData)
        .then(response => {
          resolve(response.data.transactions);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchTransactionsSource = (sourceCarId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        source_car_id: sourceCarId,
      };
  
      automobyApi
        .post("/transaction/source/list", requestData)
        .then(response => {
          resolve(response.data.transactions);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };
  
  const addTransaction = (newTransaction) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/transaction/add", newTransaction)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };


  const addTransactionSource = (newTransaction) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/transaction/source/add", newTransaction)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };


  const removeTransaction = (transactionId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        transaction_id: transactionId
      };
  
      automobyApi
        .post("/transaction/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchByDealerId = (dealerId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        dealer_id: dealerId,
      };
  
      automobyApi
        .post("/transaction/dealer", requestData)
        .then(response => {
          resolve(response.data.transactions);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const fetchByDealerIdDebt = (dealerId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        dealer_id: dealerId,
      };
  
      automobyApi
        .post("/transaction/dealer", requestData)
        .then(response => {
          resolve(response.data.transactions);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
   
  const transactionService = {
    fetchTransactions: fetchTransactions,
    addTransaction: addTransaction, 
    addTransactionSource: addTransactionSource,
    removeTransaction: removeTransaction, 
    fetchByDealerId:fetchByDealerId,
    fetchTransactionsSource:fetchTransactionsSource,
   };
   
  const transactionTransferService = { 
    addTransaction: addTransaction,  
   };

  return { transactionService, transactionTransferService };
 
}